enum IRoleLevels {
  developer = 5,
  super_admin = 4,
  admin = 3,
  employee = 2,
  partner = 1,
}

export default IRoleLevels;
